import "../util/Custom.css"

export function LoaderSuspense(){
  return (
    <div className={`overlay overlay-suspense`}>
      <img src='loading.gif' alt='Carregando' />
    </div>
  )
}